// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"414":"ead4b976","453":"d72a5e44","627":"563ca046"}[chunkId] + ".chunk.js";
};